export default function ClientDetails({ clientName, clientAddress, clientWilaya, clientEmail, clientPhone, qrCode }) {
    return (
        <>
            <div className="block sm:flex justify-between">
                <section className="mt-10 flex flex-col items-start justify-start">
                    {/*<p className="font-medium uppercase text-md mr-2 mb-2">Au nom de <span className="font-bold">BEA</span> au profit:</p>*/}
                    <div className="flex flex-row ml-2">
                        <p className="font-semibold uppercase text-sm mr-2">
                            <span className="font-extrabold text-md">BEA</span> au profit de
                        </p>
                        <p className="font-extrabold uppercase text-sm ">
                            .{clientName}
                        </p>
                    </div>
                    <div className="flex flex-row ml-2">
                        <p className="font-semibold uppercase text-sm mr-2">
                            Adresse :
                        </p>
                        <p className="font-normal uppercase text-sm ">
                            {clientAddress}
                        </p>
                    </div>
                    <div className="flex flex-row ml-2">
                        <p className="font-semibold uppercase text-sm mr-2">
                            Wilaya:
                        </p>
                        <p className="font-normal uppercase text-sm ">
                            {clientWilaya}
                        </p>
                    </div>
                    <div className="flex flex-row ml-2">
                        <p className="font-semibold uppercase text-sm mr-2">
                            Email:
                        </p>
                        <p className="font-normal uppercase text-sm ">
                            {clientEmail}
                        </p>
                    </div>  <div className="flex flex-row ml-2">
                        <p className="font-semibold uppercase text-sm mr-2">
                            TÉL:
                        </p>
                        <p className="font-normal uppercase text-sm ">
                            {clientPhone}
                        </p>
                    </div>
                </section>
                <img src={qrCode} />
            </div>
        </>
    )
}
